module.exports = __webpack_public_path__ + "static/media/ratingPoints.10bcedcd.svg";